import { BoxProps, Flex } from '@chakra-ui/react'
import { useMemo, useState, useRef } from 'react'
import gsap from 'gsap'
import Flip from 'gsap/Flip'
import { CSSPlugin } from 'gsap/CSSPlugin'
import { useInView } from 'react-intersection-observer'

import { useLuckyDrawEvents } from '../../hooks/useLuckyDrawEvents'

import FlipCard from '../FlipCard'

import useIsMobile from '../../hooks/useIsMobile'

import WowDrops from './WowDrops'
import LiveDrops from './LiveDrops'
const TOTAL_WOW_ITEMS = 3 // wow drop 显示的数量

gsap.registerPlugin(Flip, CSSPlugin)

export default function TopDrops(props: BoxProps) {
  const [isliveOnHover, setIssliveOnHover] = useState(false)
  const [iswowOnHover, setIswowOnHover] = useState(false)
  const isMobile = useIsMobile()
  const MAX_ITEM_WIDTH = useMemo(() => (isMobile ? 116 : 161.8), [isMobile])
  // inView
  const { ref: inViewRef, inView } = useInView({ threshold: 0 })

  const wowTimelineRef = useRef<gsap.core.Timeline | null>(null)

  const liveTimelineRef = useRef<gsap.core.Timeline | null>(null)
  const {
    topSkinsValues: wowDataValues,
    newSkinsValues: liveDataValues,
    isLoading,
    error,
  } = useLuckyDrawEvents({
    iswowOnHover,
    isliveOnHover,
    inView,
    liveTimelineRef,
    wowTimelineRef,
  })
  // console.log('wowData>>', wowData.length)

  // 固定宽度
  const wowDropItemWidth = MAX_ITEM_WIDTH
  // console.log('ws wowData', wowData.length)
  if (isLoading || liveDataValues.skins.length < 8) {
    return (
      <Flex
        width={'100%'}
        border="1px solid #19172d"
        my="10px"
        borderRadius={'5px'}
        display={'flex'}
        minH={['133px', '147px']}
        transition={'min-height 0.3s ease'}
        ref={inViewRef}
      >
        {Array.from({ length: 20 }).map((_, index) => {
          return (
            <FlipCard
              containerStyle={{
                width: '9.0909090909%',
                borderRight: index !== 20 ? '1px solid #19172d' : '',
              }}
              isLoaded={false}
              key={`front-${index}`}
              front={undefined}
              back={undefined}
            />
          )
        })}
      </Flex>
    )
  }

  if (
    !isLoading &&
    error &&
    wowDataValues.skins.length === 0 &&
    liveDataValues.skins.length === 0
  ) {
    return null
  }

  return (
    <Flex
      width={'100%'}
      gap={'10px'}
      py="10px"
      position={'relative'}
      overflow={'hidden'}
      ref={inViewRef}
      fontWeight={700}
      {...props}
      className="top-drops-container"
    >
      <WowDrops
        wowDataValues={wowDataValues}
        TOTAL_WOW_ITEMS={TOTAL_WOW_ITEMS}
        wowDropItemWidth={wowDropItemWidth}
        isMobile={isMobile}
        iswowOnHover={iswowOnHover}
        setIswowOnHover={setIswowOnHover}
        timelineRef={wowTimelineRef}
      />
      <LiveDrops
        liveDataValues={liveDataValues}
        dropItemWidth={wowDropItemWidth}
        isMobile={isMobile}
        isliveOnHover={isliveOnHover}
        setIssliveOnHover={setIssliveOnHover}
        timelineRef={liveTimelineRef}
      />
    </Flex>
  )
}
export function getCurrentTranslateX(element: HTMLElement) {
  const style = window.getComputedStyle(element)
  const matrix = new WebKitCSSMatrix(style.transform)
  return matrix.m41 // translateX
}
